import { useState } from 'react';
import { connect } from 'react-redux';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage } from 'react-intl';
import { ReduxState, SessionDTOExtended } from 'types';
import { Api } from 'api';
import { formatMessage } from 'i18n/CurrentLocale';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNoteSticky } from '@fortawesome/free-solid-svg-icons';
import { historicalSessionsSliceActions } from 'features/parkingsessions/historicalSessionsSlice';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import * as Sentry from '@sentry/react';


export const SESSION_NOTE_CHARACTER_LIMIT = 40;

export const EditSessionNoteModal = (props: Props) => {

    const { session, token } = props;
    const [note, setNote] = useState<string>(session?.sessionAnnotation?.sessionNote ?? '');
    const [error, setError] = useState<any>();

    const updateNote = async () => {
        try {
            setError(undefined);
            await Api.updateSessionNote(token!, { sessionPublicId: session?.publicId!, note });
            const updatedSession = { ...session, sessionAnnotation: { ...session.sessionAnnotation, sessionNote: note } };
            props.updateSessionNoteCompleted({ updatedSession });
            props.closeModal();
        } catch (e) {
            setError(e);
            Sentry.captureException(e);
        }
    }

    return (
        <div className="panel radius-rectangle full-width-form confirmation-modal">
            <div className="panel-header">
                <h1 className="bold-title">
                    <FontAwesomeIcon icon={faNoteSticky} />
                    <FormattedMessage id={session?.sessionAnnotation?.sessionNote ? 'MODAL_SESSION_NOTE_TITLE_EDIT_NOTE' : 'MODAL_SESSION_NOTE_TITLE_ADD_NOTE'} />
                </h1>
            </div>
            <div className="panel-content">

                <input type='text' className='text-field'
                    autoFocus
                    value={note}
                    maxLength={SESSION_NOTE_CHARACTER_LIMIT}
                    placeholder={formatMessage({ id: 'PLACEHOLDER_ADD_NOTE' })}
                    onChange={(e) => setNote(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' ? updateNote() : null}
                />

                <div className='align-right'>
                    <span style={{ color: note?.length < SESSION_NOTE_CHARACTER_LIMIT ? '#35D38C' : '#D34B35' }}>
                        {`${note?.length}/${SESSION_NOTE_CHARACTER_LIMIT}`}
                    </span>
                </div>

                {error && (
                    <div className='error-box' style={{ marginBottom: 0, marginTop: '20px' }}>
                        <FormattedMessage id='ERROR_SOMETHING_WENT_WRONG' />
                    </div>
                )}

                <div className="row-7">
                    <div className="col-6">
                        <button className="btn-cancel" onClick={props.closeModal}>
                            <FormattedMessage id="GLOBAL_CANCEL" />
                        </button>
                    </div>
                    <div className="col-6">
                        <button className="btn-green" onClick={updateNote}>
                            <FormattedMessage id='GLOBAL_SAVE' />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};


type OwnProps = {
    session: SessionDTOExtended
}
type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps & OwnProps;

function mapStateToProps(state: ReduxState) {
    return {
        token: state.auth.token,
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({
        closeModal: modalWindowActions.closeModal,
        updateSessionNoteCompleted: historicalSessionsSliceActions.updateSessionNoteCompleted
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditSessionNoteModal);